const FlatRoleTypes = {
    GENERAL_READ: "_GENERAL_READ",
    BREEDING: "_BREEDING",
    REPORT: "_REPORT",
    BUILDING: "_BUILDING",
    BILLING: "_BILLING",
    USER_MANAGE: "_USER_MANAGE",
    SERVICE: "_SERVICE",
    TRANSLATION: "_TRANSLATION",
    ITS: "_ITS",
    ITS_HISTORY: "_ITS_HISTORY",
    FILES: "_FILES",
    SALE: "_SALE",
    DEVICE_CAGE: "_DEVICE_CAGE",
    DEVICE_SILO: "_DEVICE_SILO",
    DEVICE_FEEDING: "_DEVICE_FEEDING",
    DEVICE_IPSUM: "_DEVICE_IPSUM",
    DEVICE_NUTRI_PRO: "_DEVICE_NUTRI_PRO",
    DEVICE_CLIMATE: "_DEVICE_CLIMATE",
    DEVICE_CHAIN: "_DEVICE_CHAIN",
    DEVICE_PIGLET_CAGE: "_DEVICE_PIGLET_CAGE",
    DEVICE_COUNTER: "_DEVICE_COUNTER",
    DEVICE_CONFIG: "_DEVICE_CONFIG",
    DEVICE_FARM_WATCH_PRO: "_DEVICE_FARM_WATCH_PRO",
    ECONOMY: "_ECONOMY",
    AI: "_ARTIFICIAL_INTELLIGENCE",
    FARM_MAP: "_FARM_MAP"
};

module.exports = FlatRoleTypes;
